module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-09-16 at 12.12.01 PM (1).79ae92ac.jpeg";